/** Sends an old Code lists link (`/code-lists?tab=…`) to its list in System settings, for good. */
import { Navigate, useLocation } from 'react-router-dom';
import { legacyCodeListsTarget } from './legacy-code-lists-target';

export function LegacyCodeListsRedirect() {
  const { search } = useLocation();
  return <Navigate to={legacyCodeListsTarget(search)} replace />;
}
